module.exports = __webpack_public_path__ + "media/images/icons/filled/caret-left-dd1292a4a157b8af7c12e7c4f1544484.svg";